import './index.scss'
import Navigation from '../Navigation'
import { useLocation, useNavigate, useParams } from 'react-router'
import classNames from 'classnames'
import { observer } from 'mobx-react'
import GlobalState from '../../stores/GlobalState'
import { ReactComponent as Logo } from '../../assets/logo/Group (1).svg'
import { useEffect } from 'react'

const Header = observer(() => {
  const navigate = useNavigate()
  const { pathname } = useLocation()

  useEffect(() => {
    setTimeout(() => {
      document.querySelector('.header')?.classList.add('visible-header')
    }, 600)
  }, [pathname])

  return (
    <header className={classNames('header ')}>
      <div className={classNames('header__container')}>
        <div className="header__left">
          <Logo
            className={classNames('header__logo')}
            onClick={() => {
              let lang = GlobalState.currentLocale.lang.includes('En')
                ? '/en/'
                : GlobalState.currentLocale.lang.includes('ру')
                ? '/ru/'
                : '/'

              if (pathname.includes('login') || pathname.includes('reg')) {
                window.location.href = document.referrer
                return
              }

              navigate(`${lang}`)
              window.location.reload()
              localStorage.removeItem('lastPos')
              // localStorage.clear()
            }}
          />
          <span className="header__separator"></span>
          <span className="header__country">Ukraine</span>
        </div>
        <Navigation />
      </div>
    </header>
  )
})

export default Header
